let rootPath = null

export function getRootPath () {
  return rootPath
}

export function setRootPath (toPath) {
  rootPath = toPath
}
